var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', {
    attrs: {
      "class-name": "member_detail",
      "title": $t("obrz2", "详情"),
      "width": _vm.isMobile ? '90%' : '700px',
      "mask-closable": false
    },
    model: {
      value: _vm.visiable,
      callback: function ($$v) {
        _vm.visiable = $$v;
      },
      expression: "visiable"
    }
  }, [_c('section', {
    staticClass: "flex flex-col gap-[20px] mb-[10px]"
  }, [_c('main', {
    staticClass: "card-info flex gap-[30px] p-[20px]"
  }, [_c('img', {
    staticClass: "w-[64px] h-[64px] rounded-full",
    attrs: {
      "src": require("../../../../assets/user_init_logo.png")
    }
  }), _c('div', {
    staticClass: "flex flex-col justify-center"
  }, [_c('span', {
    staticClass: "text-[#000] text-[18px] line-[32px]"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))]), _c('p', {
    staticClass: "flex text-[#8490A2] flex-wrap xl:gap-[30px] gap-[10px] items-center"
  }, [_c('span', {}, [_vm._v("Iwork ID: "), _c('span', {
    staticClass: "text-[#000]"
  }, [_vm._v(_vm._s(_vm.userDetail.userId))])]), _c('span', {}, [_vm._v("|")]), _c('span', {
    staticClass: "p-[2px] text-[#05A660]"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userDetail.status === 10,
      expression: "userDetail.status === 10"
    }],
    staticClass: "bg-[#E3FFF1] text-[#05A660] p-1"
  }, [_vm._v(` ${$t("fj1g2", "在职")} `)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userDetail.status === 50,
      expression: "userDetail.status === 50"
    }],
    staticClass: "bg-[#FFE6E6] text-[#E63535] p-1"
  }, [_vm._v(` ${$t("lb5z2", "禁用")} `)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userDetail.status === 99,
      expression: "userDetail.status === 99"
    }],
    staticClass: "bg-[#FFF8E6] text-[#FF8800] p-1"
  }, [_vm._v(` ${$t("ler52", "离职")} `)])])])])]), _c('Form', {
    staticClass: "flex flex-col",
    attrs: {
      "model": _vm.userDetail,
      "rules": _vm.myRules
    }
  }, [_c('main', {
    staticClass: "p-[20px] card-info flex flex-col gap-[20px]"
  }, [_c('p', {
    staticClass: "text-[#000] text-[18px] line-[32px]"
  }, [_vm._v($t("blh1h04", "基础信息"))]), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-[20px]"
  }, [_c('FormItem', {
    attrs: {
      "label": $t("hmxge3", "用户名"),
      "prop": "userName"
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])]), _c('FormItem', {
    attrs: {
      "label": $t("i1y32", "昵称"),
      "prop": "userNickname"
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(" " + _vm._s(_vm.userDetail.userNickname || $t("dd8lzs4", "暂未设置")) + " ")])]), _c('FormItem', {
    attrs: {
      "label": $t("fvdo2", "姓氏"),
      "prop": "userSurname"
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(" " + _vm._s(_vm.userDetail.userSurname || $t("dd8lzs4", "暂未设置")) + " ")])]), _c('FormItem', {
    attrs: {
      "label": $t("esq22", "名字"),
      "prop": "userGivenName"
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(" " + _vm._s(_vm.userDetail.userGivenName || $t("dd8lzs4", "暂未设置")) + " ")])]), _c('FormItem', {
    attrs: {
      "label": $t("f6ql714", "用户代码")
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(" " + _vm._s(_vm.userDetail.userCode || $t("dd8lzs4", "暂未设置")) + " ")])]), _c('FormItem', {
    attrs: {
      "label": $t("ewbd43", "手机号")
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm.userDetail.userMobile ? _c('ProEncInput', {
    key: `mobile-${_vm.userDetail.userId}`,
    attrs: {
      "disabled": "",
      "params": {
        unitId: this.row.unitId,
        userId: this.userDetail.userId
      },
      "mode": "UNIT_USER_MOBILE"
    },
    model: {
      value: _vm.userDetail.userMobile,
      callback: function ($$v) {
        _vm.$set(_vm.userDetail, "userMobile", $$v);
      },
      expression: "userDetail.userMobile"
    }
  }) : _c('div', {
    staticClass: "info-content"
  }, [_vm._v($t("dd8lzs4", "暂未设置"))])], 1)]), _c('FormItem', {
    attrs: {
      "label": $t("padf2", "邮箱")
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm.userDetail.userEmail ? [_c('ProEncInput', {
    key: `email-${_vm.userDetail.userId}`,
    attrs: {
      "disabled": "",
      "params": {
        unitId: this.row.unitId,
        userId: this.userDetail.userId
      },
      "mode": "UNIT_USER_EMAIL"
    },
    model: {
      value: _vm.userDetail.userEmail,
      callback: function ($$v) {
        _vm.$set(_vm.userDetail, "userEmail", $$v);
      },
      expression: "userDetail.userEmail"
    }
  })] : _c('span', [_vm._v($t("dd8lzs4", "暂未设置"))])], 2)]), _c('FormItem', {
    attrs: {
      "label": $t("gfjm2", "工号")
    }
  }, [_c('div', {
    staticClass: "info-content"
  }, [_vm._v(" " + _vm._s(_vm.userDetail.userNumber || $t("dd8lzs4", "暂未设置")) + " ")])]), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("pgxs2", "部门")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_vm.userDetail.departments && _vm.userDetail.departments.length > 0 ? _c('div', {
    staticClass: "flex flex-wrap gap-1"
  }, _vm._l(_vm.userDetail.departments, function (item) {
    return _c('span', {
      key: item.orgId,
      staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px] text-[14px] text-[14px] leading-[14px] text-[#000]"
    }, [_c('Icon', {
      staticClass: "mr-[2px] text-[#2d8cf0]",
      attrs: {
        "type": "md-folder"
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")], 1);
  }), 0) : _c('div', {
    staticClass: "info-content"
  }, [_vm._v($t("dd8lzs4", "暂未设置"))])])]), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("g6mu2", "岗位")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_vm.userDetail.positions && _vm.userDetail.positions.length > 0 ? _c('div', {
    staticClass: "flex flex-wrap gap-1"
  }, _vm._l(_vm.userDetail.positions, function (item) {
    return _c('span', {
      key: item.tagId,
      staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px] text-[14px] text-[14px] leading-[14px] text-[#000]"
    }, [_c('Icon', {
      staticClass: "mr-[2px] text-[#2d8cf0]",
      attrs: {
        "type": "md-pricetag"
      }
    }), _vm._v(_vm._s(item.name))], 1);
  }), 0) : _c('div', {
    staticClass: "info-content"
  }, [_vm._v($t("dd8lzs4", "暂未设置"))])])]), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("gqac2", "应用")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_vm.userDetail.apps && _vm.userDetail.apps.length > 0 ? _c('div', {
    staticClass: "flex flex-wrap gap-1"
  }, _vm._l(_vm.userDetail.apps, function (item) {
    return _c('span', {
      key: item.appId,
      staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px] text-[14px] text-[14px] leading-[14px] text-[#000]"
    }, [_c('Icon', {
      staticClass: "mr-[2px] text-[#2d8cf0]",
      attrs: {
        "type": "md-apps"
      }
    }), _vm._v(_vm._s(item.name))], 1);
  }), 0) : _c('div', {
    staticClass: "info-content"
  }, [_vm._v($t("dd8lzs4", "暂未设置"))])])])], 1)])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };